import { ArrowRightLeft, MoveRight } from "lucide-react";

function playerName(player) {
  return player.name || player.apelido || "Jogador";
}

export function PlayerMoveOptions({ selectedPlayer, sourceTeamIndex, teams, onMove }) {
  return (
    <div className="team-adjustment-section" data-testid="move-player-options">
      <h3><MoveRight size={16} /> Mover para outro time</h3>
      <div className="team-adjustment-options">
        {teams.map((team, index) => (
          <button
            className="team-adjustment-option"
            disabled={index === sourceTeamIndex}
            key={team.name}
            onClick={() => onMove(selectedPlayer.id, index)}
            data-testid={`move-player-${selectedPlayer.id}-to-team-${index}`}
          >
            <span>{team.name}</span>
            <small>{team.players.length} jogadores</small>
          </button>
        ))}
      </div>
    </div>
  );
}

export function PlayerSwapOptions({ selectedPlayer, sourceTeamIndex, teams, onSwap }) {
  const choices = teams.flatMap((team, teamIndex) => (
    teamIndex === sourceTeamIndex ? [] : team.players.map((player) => ({ player, team }))
  ));

  return (
    <div className="team-adjustment-section" data-testid="swap-player-options">
      <h3><ArrowRightLeft size={16} /> Trocar com jogador</h3>
      <div className="team-adjustment-options">
        {choices.map(({ player, team }) => (
          <button
            className="team-adjustment-option player-swap-option"
            key={player.id}
            onClick={() => onSwap(selectedPlayer.id, player.id)}
            data-testid={`swap-player-${selectedPlayer.id}-with-${player.id}`}
          >
            <span>{playerName(player)}</span>
            <small>{team.name}</small>
          </button>
        ))}
      </div>
    </div>
  );
}